
import {FBColumnOptions} from "./FBColumn.Options";
import {StoreBase, StoreDataType} from "shared/core/Store/StoreBase";


export class FBRowOptions extends StoreBase{
    @StoreDataType(FBColumnOptions)
    public Columns:FBColumnOptions[];
    public StepId:number;
    protected LoadDefaultValues() {
        this.Columns=[];
        this.StepId=0;
    }



}